import { render, staticRenderFns } from "./deposit.vue?vue&type=template&id=3e38fa7a&"
import script from "./deposit.vue?vue&type=script&lang=js&"
export * from "./deposit.vue?vue&type=script&lang=js&"
import style0 from "./deposit.vue?vue&type=style&index=0&id=3e38fa7a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports